import {useMemo} from 'react';
import {LogMessageType} from '../../services/LogMessagesType';
import {ApiResponsePending} from '../../services/ApiResponseType';
import {useApiService} from '../../services/helpers';
import { AcknowledgementService } from '../../services/generated/services/AcknowledgementService';
import { AcknowledgementTemplateDto } from '../../services/generated/models/AcknowledgementTemplateDto';

export const useAcknowledgementTemplate = () => {
  const requestWrapper = useApiService();

  const getUnitsTemplates = (
    unitId: number,
    log: LogMessageType = {
      error: true
    }
  ): ApiResponsePending<AcknowledgementTemplateDto[]> => {
    return requestWrapper(
      AcknowledgementService.getUnitAcknowledgementTemplates(unitId),
      apiCode => apiCode,
      log
    );
  };

  const getTemplateById = (
    templateId: number,
    log: LogMessageType = {
      error: true
    }
  ): ApiResponsePending<AcknowledgementTemplateDto> => {
    return requestWrapper(
      AcknowledgementService.getTemplateById(templateId),
      result => result,
      log,
      
    );
  };


    const createTemplate = (
    requestBody: AcknowledgementTemplateDto,
    log: LogMessageType = {
      error: true,
      success: true,
      successMessage: `Acknowledgement Template form created successfully`
    }
  ): ApiResponsePending<AcknowledgementTemplateDto> => {
    return requestWrapper(
      AcknowledgementService.postApiCreateAcknowledgementTemplate(requestBody),
      result => result,
      log
    );
  };


  const updateTemplate = (
    requestBody: AcknowledgementTemplateDto,
    log: LogMessageType = {
      error: true,
      success: true,
      successMessage: `Acknowledgement Template form updated successfully`
    }
  ): ApiResponsePending<AcknowledgementTemplateDto[]> => {
    return requestWrapper(
      AcknowledgementService.postApiUpdateAcknowledgementTemplate(requestBody),
      result => result,
      log
    );
  };

    const deleteTemplate = async (
      unitId: number,
      id: number,
      log: LogMessageType = {
        error: true,
        success: true,
        successMessage: `Acknowledgement Template form deleted successfully`
      }
    ) => {
      return await requestWrapper(
        AcknowledgementService.deleteTemplate(unitId, id),
        result => result ?? [],
        log
      );
    };


  return useMemo(
    () => ({
      getTemplateById,
      createTemplate,
      getUnitsTemplates,
      updateTemplate,
      deleteTemplate,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
};
